//  * Create and Edit Order
import React, { useState, useEffect } from 'react'
// components
import { useForm } from 'react-hook-form'
import { isEmpty, values } from 'lodash'
// UI
import {
  Grid,
  Button,
  Typography,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  Divider,
  Box,
  TextField,
  CircularProgress,
  CardContent,
  Card
} from '@material-ui/core'
import Modal from '../../components/Modal'
import Add from './components/add'
import AddVitrin from './components/addVitrin'
import jMoment from 'moment-jalaali'
import classes from './index.module.scss'
// Type
import { AddItemCreateParcel } from '../parcels/interfaces'
import {
  Inputs,
  Contact,
  Location,
  Props,
  dataShippingProps,
  NumberComparison,
  FulfillmentTypesState
} from './types'

// helpers'
import {
  removeEmptyValueObject,
  convertPersianDigit2English,
  translate
} from '../../utils/helpers'

import { useHistory } from 'react-router-dom'
import handleNotification from '../../utils/handleNotfication'
import handleError from '../../utils/handleError'
import { Order, orderItemsCreate } from '../orders/interfaces'

import CustomerInfo from '../../components/sections/createOrder/customerInfo'
import InputContacts from '../../components/inputs/inputContacts'
import ProductList from '../../components/sections/createOrder/productList'
import OrderInputs from '../../components/inputs/orderInputs'
import FileWithLink from '../../components/inputs/fileWithLink'
import ConfirmModal from '../../components/Modal/confirm'
import ordersRepository from 'client-sdk/src/Repository/orders-repository'
import OrderItemsRepository from 'client-sdk/src/Repository/order-items.repository'
import ContactsRepository from 'client-sdk/src/Repository/contacts-repository'
import getOrderFileReq from 'client-sdk/src/orders/files'
import linkValidation from '../../utils/validations/linkValidation'
import { Helmet } from 'react-helmet'
import RonadIcons from '../../components/iconComponent'
import ContactList from '../../components/lists/contactList'
import env from 'client-sdk/src/enviroments/enviroment'
import disableElement from '../../utils/disableElement'
import digikalaValidation from 'client-sdk/src/orders/digikalaValidation'

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true })

function CreateOrder(props: Props) {
  const partnerId = Number(localStorage.getItem('partnerId'))
  const features = JSON.parse(localStorage.getItem('profile') || '[]')
  const history = useHistory()
  const form = useForm<Inputs>({
    shouldUnregister: false,
    defaultValues: {
      orderType: 'WITHOUT_CENTER',
      orderTplType: 'RONAD',
      deliveryDate: null,
      deliveryTime: '',
      deliveryStartTime: null,
      deliveryEndTime: null,
      origin: '',
      destination: '',
      customerName: '',
      fulfillmentTypeId: null,
      deliveryServiceId: null,
      courierId: null,
      cutoffId: null,
      customerNationalCode: '',
      customerMobileNumber: '',
      customerPhoneNumber: '',
      customerProvince: '',
      customerCity: '',
      customerZipCode: '',
      deliveryType: '',
      trackingCode: '',
      customerAddress: '',
      description: '',
      cost: '',
      weight: '',
      orderValue: '',
      packageCode: '',
      deliveryCode: '',
      senderName: '',
      codPaymentCode: '',
      location: {
        lat: null,
        lng: null
      }
    }
  })

  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset
  } = form
  const [deliveryLocationType, setDeliveryLocationType] =
    useState<boolean>(false)
  const [cod, setCod] = useState<any>(false)
  const [postPaid, setPostPaid] = useState<any>(false)
  const [fulfillmentLine, setFulfillmentLine] = useState<number | null | any>(
    null
  )
  const [orderTplType, setOrderTplType] = useState<any>('RONAD')
  const [orderValue, setOrderValue] = useState<any>()
  const [cost, setCost] = useState<any>()
  const [invoiceLink, setInvoiceLink] = useState<any>('')
  const [invoiceFile, setInvoiceFile] = useState<any>('')
  const [invoiceFileName, setInvoiceFileName] = useState<any>(null)
  const [labelLink, setLabelLink] = useState<any>('')
  const [labelFile, setLabelFile] = useState<any>('')
  const [labelFileName, setLabelFileName] = useState<any>(null)
  const [notifType, setNotifType] = useState('')
  const [isInvoiceFileChange, setIsInvoiceFileChange] = useState<any>(false)
  const [isLabelFileChange, setIsLabelFileChange] = useState<any>(false)

  const [dialog, setDialog] = useState<string>('')
  const [items, setItems] = useState<any>([])
  const [itemDeleted, setItemDeleted] = useState<any>({})
  const [id, setId] = useState<any>(1)
  const [itemsInfo, setItemsInfo] = useState<any>([])
  const [location, setLocations] = useState<Location | undefined>({
    lat: 0,
    lng: 0
  })
  const [formData, setFormData] = useState<any>(null)
  const [orderId] = useState<number>(props.match.params.id)
  const [editMode, setEditMode] = useState(false as boolean)
  const [isVitrinOrderItem, setIsVitrinOrderItem] = useState(false as boolean)
  const [order, setOrder] = useState<Order>({})
  const [orderItems, setOrderItems] = useState()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [extractLoading, setExtractLoading] = useState(false)
  const [selected, setSelected] = useState()
  const [notFounded, setNotFounded] = useState([])
  const [extraLabelRequired, SetExtraLabelRequired] = useState(false)
  const [addressDisabled, SetAddressDisabled] = useState(false)
  const [deliveryTime, setDeliveryTime] = useState<any>('')
  const [locatedInTehran, setLocatedInTehran] = useState<any>('')
  const [contactsCourier, setContactsCourier] = useState<any>([])
  const [listContact, setListContact] = useState<any>([])
  const [contactId, setContactId] = useState<any>([])
  const [LoadReceiverInfo, setLoadReceiverInfo] = useState(false)
  const [openDialogComparison, setOpenDialogComparison] = useState('')
  const [isInvoiceLoading, setIsInvoiceLoading] = useState(false)
  const [isLabelLoading, setIsLabelLoading] = useState(false)
  const [notMatch, setNotMatch] = useState('')
  const [checkFilesRequired, setCheckFilesRequired] = useState(false)

  const [numberInvoiceFile, setNumberInvoiceFile] = useState<NumberComparison>({
    variantCount: null,
    totalCount: null
  })
  const [numberLabelFile, setNumberLabelFile] = useState<NumberComparison>({
    variantCount: null,
    totalCount: null
  })
  const [numberProductList, setNumberProductList] = useState<NumberComparison>({
    variantCount: null,
    totalCount: null
  })

  const [fulfillmentTypes, setFulfillmentTypes] =
    useState<FulfillmentTypesState>({
      selectedFulfillmentType: null,
      fulfillmentTypeNext: null
    })
  const [dataShipping, setDataShipping] = useState<dataShippingProps>({
    fulfillmentLineDTO: { id: 0, name: '' },
    orderDeliveryLocationTypeDTO: { name: '' },
    orderDeliveryTypeDTO: { name: '' },
    orderPaymentTypeDTO: { name: '' },
    orderTPLTypeDTO: { name: '' },
    postPaid: false
  })

  const [formFieldsId, setFormFieldsId] = useState({
    fulfillmentTypeId: null,
    courierId: null,
    deliveryServiceId: null,
    cutoffId: null
  })

  useEffect(() => {
    if (orderId) {
      setEditMode(true)
    }
  }, [])
  useEffect(() => {
    if (editMode) {
      getOrder({ id: orderId })
      getOrderItems({ 'orderId.equals': orderId, size: 1000 })
    }
  }, [editMode])

  useEffect(() => {
    if (!isEmpty(order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        codValue,
        description,
        fulfillmentWarehouseId,
        customerLat,
        customerLon,
        paymentType,
        weight,
        orderValue,
        packageCode,
        deliveryCode,
        codPaymentCode,
        orderTPLType,
        receiptFileName,
        labelFileName,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        cutoffId,
        senderName,
        receiptUrl,
        fulfillmentAttachmentUrl,
        postPaid
      } = order

      const payload = {
        orderType,
        deliveryDate,
        deliveryStartTime: deliveryDate + ' ' + deliveryStartTime,
        deliveryEndTime: deliveryDate + ' ' + deliveryEndTime,
        deliveryTime:
          deliveryStartTime === '11:00:00'
            ? '11-15'
            : deliveryStartTime === '16:00:00'
            ? '16-20'
            : '',
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        description,
        origin: fulfillmentWarehouseId,
        destination: null,
        weight,
        senderName,
        orderValue,
        packageCode,
        deliveryCode,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        cutoffId,
        codPaymentCode
      }
      setCost(codValue)
      setOrderValue(orderValue)
      setPostPaid(postPaid)
      setOrderTplType(orderTPLType ? orderTPLType : 'RONAD')
      setInvoiceFileName(receiptFileName)
      setLabelFileName(labelFileName)
      setInvoiceLink(receiptUrl)
      setLabelLink(fulfillmentAttachmentUrl)
      if (order.deliveryLocationType == 'IN_RONAD') {
        setDeliveryLocationType(true)
      }
      if (paymentType === 'COD') {
        setCod(true)
      } else {
        setCod(false)
      }
      setFulfillmentLine(order.fulfillmentLineId)
      const location = {
        lat: Number(customerLat),
        lng: Number(customerLon)
      }
      if (location.lat && location.lng) {
        handleLocations(location)
      }
      reset(payload)
    }
  }, [order])

  useEffect(() => {
    if (editMode && orderItems) {
      setItemsInfo(orderItems)
    }
  }, [orderItems])

  useEffect(() => {
    if (addressDisabled) {
      setValue(
        'customerAddress',
        'تهران، محله شادآباد، خیابان ١٧ شهریور، بین شهدای اسلامی و بسیج مستضعفین، شرکت روناد'
      )
      setNotifType('deliveryLocation')
    } else {
      setValue('customerAddress', '')
      setNotifType('')
    }
  }, [addressDisabled])

  useEffect(() => {
    if (locatedInTehran) {
      setValue('customerProvince', 'تهران')
      setValue('customerCity', 'تهران')
    } else {
      setValue('customerAddress', '')
      setValue('customerProvince', '')
      setValue('customerCity', '')
      setNotifType('')
    }
  }, [locatedInTehran])

  useEffect(() => {
    if (getValues('deliveryType') == 'COURIER') {
      setNotifType('COURIER')
    } else {
      setNotifType('')
    }
  }, [getValues('deliveryType')])

  const onSubmit = (data: Inputs) => {
    if (extraLabelRequired && (isLabelValid() || isInvoiceValid())) {
      handleNotification(
        `فایل ${
          isInvoiceValid() ? 'فاکتور' : 'لیبل'
        } را به سفارش اضافه نکرده‌اید`,
        'error'
      )
      return
    }

    if (editMode) {
      setFormData(data)
      setDialog('confirmationOrder')
      return
    }
    if (itemsInfo.length === 0) {
      handleNotification('کالایی را به سفارش اضافه نکرده‌اید', 'warn')
    } else {
      setFormData(data)
      setDialog('confirmationOrder')
    }
  }

  const isLabelValid = () => {
    return !labelLink && !labelFileName
  }

  const isInvoiceValid = () => {
    return !invoiceLink && !invoiceFileName
  }

  const createItemsToOrder = (body: AddItemCreateParcel) => {
    if (isVitrinOrderItem) {
      const { count, product, variant, price, fulfillmentVariantCode } = body
      setId(id + 1)
      const idItem = product?.id
      const variantId = variant?.id
      const dubItems = itemsInfo.filter((el: any) => el.variantId === variantId)
      if (dubItems.length > 0) {
        itemsInfo.map((el: any) => {
          if (el.variantId === variantId) {
            el.amount = +el.amount + +count
          }
        })
      } else {
        setItemsInfo([
          ...itemsInfo,
          {
            id,
            productId: idItem,
            fulfillmentVariantCode,
            featureAndValues: variant?.features,
            type: product?.type,
            sellerName: variant?.sellerName,
            providerName: variant?.providerName,
            amount: count,
            productName: product?.name,
            productCode: product?.code,
            variantCode: variant?.code,
            variantId: variant,
            price
          }
        ])
      }
    } else {
      const {
        count,
        product,
        variant,
        boxCount,
        countOfBox,
        fulfillmentVariantCode
      } = body
      setId(id + 1)
      const idItem = product?.id
      const variantId = variant?.id
      const dubItems = itemsInfo.filter((el: any) => el.variantId === variantId)
      if (dubItems.length > 0) {
        itemsInfo.map((el: any) => {
          if (el.variantId === variantId) {
            el.amount = +el.amount + +count
          }
        })
      } else {
        setItemsInfo([
          ...itemsInfo,
          {
            id,
            productId: idItem,
            fulfillmentVariantCode,
            featureAndValues: variant?.features,
            type: product?.type,
            sellerName: variant?.sellerName,
            providerName: variant?.providerName,
            amount: count,
            productName: product?.name,
            productCode: product?.code,
            variantCode: variant?.code,
            variantId: variant?.id,
            boxCount,
            countOfBox
          }
        ])
        setNotFounded([])
      }
    }
    setDialog('')
  }
  const setConfirmDelete = (body: any) => {
    setDialog('openConfirmDelete')
    setItemDeleted(body)
  }
  const deleteItemsFromOrder = () => {
    if (editMode) {
      deleteOrderItemOnEditMode({ id: itemDeleted.id })
    } else {
      deleteOrderItemOnCreateMode(itemDeleted.id)
    }
    setDialog('')
  }
  const handleLocations = (data: { lat: number; lng: number }) => {
    setLocations(data)
  }
  const onInvoiceDelete = () => {
    setInvoiceLink('')
    setInvoiceFile('')
    setIsInvoiceFileChange(true)
    setInvoiceFileName('')
  }
  const onLabelDelete = () => {
    setLabelLink('')
    setLabelFile('')
    setIsLabelFileChange(true)
    setLabelFileName('')
  }

  const handleSubmitOrder = async () => {
    try {
      const inventoryItems = itemsInfo.map((el: any) => {
        return {
          amount: el.amount,
          productCode: el.productCode,
          productName: el.productName,
          variantId: el.variantId,
          fulfillmentVariantCode: el.fulfillmentVariantCode
            ? el.fulfillmentVariantCode
            : null
        }
      })
      const {
        origin,
        deliveryDate: deliver,
        deliveryType,
        cutoffId,
        senderName,
        weight,
        packageCode,
        deliveryCode,
        codPaymentCode
      } = formData
      if (deliver.date) {
        var deliveryDate = convertPersianDigit2English(
          deliver.format('YYYY-MM-DD')
        )
      } else {
        var deliveryDate = deliver
      }
      const payload = {
        orderType: 'WITHOUT_CENTER',
        centerId: '',
        partnerId,
        fulfillmentWarehouseId: origin ? origin : env.destinationId,
        deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          deliveryTime?.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: convertPersianDigit2English(
          deliveryTime?.substring(3, 5).concat(':00:00')
        ),
        items: editMode ? undefined : inventoryItems,
        id: editMode ? +orderId : undefined,
        fulfillmentLineId: dataShipping.fulfillmentLineDTO.id,
        fulfillmentLineName: dataShipping.fulfillmentLineDTO.name,
        deliveryType: dataShipping.orderDeliveryTypeDTO.name,
        paymentType: dataShipping.orderPaymentTypeDTO.name,
        postPaid: dataShipping.postPaid,
        orderTPLType: dataShipping.orderTPLTypeDTO?.name,
        weight,
        senderName,
        orderValue,
        codValue: cost,
        cutoffId: formFieldsId.cutoffId,
        deliveryServiceId: formFieldsId.deliveryServiceId,
        courierId: formFieldsId.courierId,
        fulfillmentTypeId: formFieldsId.fulfillmentTypeId,
        packageCode,
        deliveryCode,
        codPaymentCode,
        isChangedLabelFile: !fulfillmentLine ? true : isLabelFileChange,
        isChangedReceiptFile: isInvoiceFileChange,
        deliveryLocationType: dataShipping.orderDeliveryLocationTypeDTO.name
      }

      const files = new FormData()
      files.append(
        'receiptFile',
        isInvoiceFileChange && invoiceFile ? invoiceFile : new Blob([''])
      )

      files.append('labelFile', getlabelFile())
      if (editMode) {
        const body = new Blob(
          [
            JSON.stringify({
              ...removeEmptyValueObject(payload),
              ...removeEmptyValueObject(collectCustomerInfo())
            })
          ],
          {
            type: 'application/json'
          }
        )
        files.append('updateOrderDTO', body)
        updateOrder(files)
      } else {
        const body = new Blob(
          [
            JSON.stringify({
              ...payload,
              ...removeEmptyValueObject(collectCustomerInfo())
            })
          ],
          {
            type: 'application/json'
          }
        )
        files.append('createOrderDTO', body)
        createOrder(files)
      }
    } catch (err: any) {
      handleError(err)
    }
  }

  const getlabelFile = () => {
    if (!extraLabelRequired) {
      return new Blob([''])
    }
    if (isLabelFileChange && labelFile) {
      return labelFile
    }

    return new Blob([''])
  }

  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(orderId, { fileType: type })
      const file = URL.createObjectURL(response.blob)
      return file
    } catch (error: any) {
      handleError(error)
      return error
    }
  }
  const collectCustomerInfo = () => {
    const {
      customerAddress,
      customerCity,
      customerMobileNumber,
      customerName,
      customerNationalCode,
      customerPhoneNumber,
      customerProvince,
      customerZipCode,
      description,
      trackingCode
    } = formData
    return {
      customerCity: listContact ? listContact.city : customerCity,
      customerMobileNumber: listContact
        ? listContact.mobile
        : customerMobileNumber,
      customerName,
      customerNationalCode: customerNationalCode
        ? customerNationalCode
        : listContact
        ? listContact.nationalCode
        : '1111111111',
      customerPhoneNumber: '02177777777',
      customerProvince: listContact ? listContact.province : customerProvince,
      customerZipCode: customerZipCode ? customerZipCode : '1111111111',
      description: listContact ? listContact.description : description,
      receiptUrl: invoiceLink,
      fulfillmentAttachmentUrl: labelLink,
      trackingCode,
      customerLat: listContact ? listContact.lat : location?.lat,
      customerLon: listContact ? listContact.lon : location?.lng,
      customerAddress: listContact ? listContact.address : customerAddress
    }
  }
  const createOrder = async (body: any) => {
    try {
      setSubmitLoading(true)
      await ordersRepository.createOrder({ payload: { body } })
      handleNotification('سفارش شما با موفقیت ثبت گردید.', 'success')
      setSubmitLoading(false)
      history.push('/orders')
    } catch (err: any) {
      setSubmitLoading(false)
      if (err.response?.status == 400) {
        if (err.response?.data?.fieldErrors?.length > 0) {
          err.response.data.fieldErrors.forEach((el: any) => {
            handleNotification(
              `مقدار فیلد ${translate(el.field)} اشتباه است`,
              'error'
            )
          })
        } else if (err.response.data?.title) {
          handleError(err)
        }
      } else if (
        err.response?.status == 406 &&
        err.response?.data?.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
        err.response.data.errorList.forEach((el: any) => {
          handleNotification(
            `کالا با کد ${el.productCode} و کدتنوع ${el.variantCode} موجود نیست`,
            'error'
          )
        })
      } else if (err.response?.status == 409) {
        handleNotification(`مقدار فیلد کد رهگیری تکراری است`, 'error')
      } else {
        handleError(err)
      }
    }
  }
  const createOrderItem = async (payload: any) => {
    try {
      const { response } = await ordersRepository.createOrderItems({ payload })
      setItemsInfo((prev: any) => [...prev, response.data])
      setDialog('')
      setNotFounded([])
    } catch (error) {
      handleError(error)
    }
  }
  const updateOrder = async (body: any) => {
    try {
      setSubmitLoading(true)
      await ordersRepository.newUpdateOrder({ payload: { body } })
      handleNotification('سفارش شما با موفقیت ویرایش گردید.', 'success')
      setSubmitLoading(false)
      history.push('/orders')
    } catch (error) {
      setSubmitLoading(false)
      handleError(error)
    }
  }
  const getOrder = async (payload: any) => {
    try {
      const response = await ordersRepository.getOrderWithId({ payload })
      setOrder(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const getOrderItems = async (payload: any) => {
    try {
      const response = await ordersRepository.getAllOrderItems({ payload })
      setOrderItems(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const deleteOrderItemOnEditMode = async (payload: any) => {
    try {
      await ordersRepository.deleteOrderItem({ payload })
      const newValue = items.filter((item: any) => item.id !== payload.id)
      const newValueInfo = itemsInfo.filter(
        (item: any) => item.id !== payload.id
      )
      setItemsInfo(newValueInfo)
      setItems(newValue)
      handleNotification('ایتم انتخابی با موفقیت حذف گردید', 'success')
    } catch (error) {
      handleError(error)
    }
  }
  const deleteOrderItemOnCreateMode = (id: string) => {
    const newValue = items.filter((item: any) => item.id !== id)
    const newValueInfo = itemsInfo.filter((item: any) => item.id !== id)
    setItems(newValue)
    setItemsInfo(newValueInfo)
  }
  const handleSubmitOrderItems = (data: AddItemCreateParcel) => {
    const payload: orderItemsCreate = {
      amount: +data.count,
      productCode: data.productCode,
      fulfillmentVariantCode: data.fulfillmentVariantCode,
      productName: data.product?.name!,
      type: 'PRODUCT',
      variantId: data.variant?.id!,
      volume: 0,
      weight: data.product?.weight!
    }
    createOrderItem({ body: payload, id: orderId })
  }
  const handleCloseFactorModal = () => {
    if (dialog == 'invoiceModal') {
      setInvoiceLink('')
    }
    if (dialog == 'labelModal') {
      setLabelLink('')
    }
    setDialog('')
  }
  const handleInvoiceLink = (e: any) => {
    setInvoiceLink(e.target?.value)
  }
  const isLinkAddressButtonDisabled = () => {
    if (dialog == 'invoiceModal') {
      return !invoiceLink || linkValidation(invoiceLink)
    } else {
      return !labelLink || linkValidation(labelLink)
    }
  }

  const labelFileChange = async (e: any) => {
    if (checkFilesRequired) {
      setIsLabelLoading(true)
      try {
        const res = await digikalaValidation(
          'DIGIKALA_LABEL',
          e.target.files[0]
        )
        setIsLabelLoading(false)
        setLabelFile(e.target.files[0])
        setLabelFileName(e.target.files[0].name)
        setIsLabelFileChange(true)
        if (res.ok) {
          setNumberLabelFile({
            variantCount: res.res.variantCount,
            totalCount: res.res.totalCount
          })
        } else {
          setOpenDialogComparison('فایل آپلود شده مربوط به لیبل نیست!')
          setNumberLabelFile({
            variantCount: null,
            totalCount: null
          })
        }
      } catch (error) {}
    } else {
      setIsLabelLoading(false)
      setLabelFile(e.target.files[0])
      setLabelFileName(e.target.files[0].name)
      setIsLabelFileChange(true)
    }
  }

  const invoiceFileChange = async (e: any) => {
    if (checkFilesRequired) {
      setIsInvoiceLoading(true)
      try {
        const res = await digikalaValidation(
          'DIGIKALA_RECEIPT',
          e.target.files[0]
        )
        setIsInvoiceLoading(false)
        setInvoiceFile(e.target.files[0])
        setInvoiceFileName(e.target.files[0].name)
        setIsInvoiceFileChange(true)

        if (res.ok) {
          setNumberInvoiceFile({
            variantCount: res.res.variantCount,
            totalCount: res.res.totalCount
          })
        } else {
          setNumberInvoiceFile({
            variantCount: null,
            totalCount: null
          })
          setOpenDialogComparison('فایل آپلود شده مربوط به محموله نیست!')
        }
      } catch (error) {}
    } else {
      setIsInvoiceLoading(false)
      setInvoiceFile(e.target.files[0])
      setInvoiceFileName(e.target.files[0].name)
      setIsInvoiceFileChange(true)
    }
  }

  useEffect(() => {
    if (checkFilesRequired && !editMode) {
      setInvoiceFileName(null)
      setLabelFileName(null)
    }
  }, [checkFilesRequired])

  useEffect(() => {
    if (
      numberInvoiceFile.totalCount &&
      numberLabelFile.totalCount &&
      checkFilesRequired &&
      invoiceFileName &&
      labelFileName
    ) {
      if (
        numberInvoiceFile.totalCount !== numberLabelFile.totalCount ||
        numberInvoiceFile.variantCount !== numberLabelFile.variantCount
      ) {
        setOpenDialogComparison(
          'تعداد کالاهای فایل لیبل و رسید محموله تطابق ندارند!'
        )
      }
    }
  }, [numberLabelFile, numberInvoiceFile, invoiceFileName, labelFileName])

  useEffect(() => {
    if (
      numberInvoiceFile.totalCount &&
      numberLabelFile.totalCount &&
      checkFilesRequired &&
      dialog === 'confirmationOrder'
    ) {
      if (
        numberInvoiceFile.totalCount !== numberLabelFile.totalCount ||
        numberInvoiceFile.totalCount !== numberProductList.totalCount ||
        numberLabelFile.totalCount !== numberProductList.totalCount ||
        numberInvoiceFile.variantCount !== numberLabelFile.variantCount ||
        numberInvoiceFile.variantCount !== numberProductList.variantCount ||
        numberLabelFile.variantCount !== numberProductList.variantCount
      ) {
        setNotMatch('تعداد کالاهای سفارش با رسید محموله و لیبل تطابق ندارند.')
      } else {
        setNotMatch('')
      }
    }
  }, [dialog])

  const getOrderWithFile = async () => {
    const file = new FormData()
    file.append('file', invoiceFile)
    try {
      const response = await OrderItemsRepository.extractOrderItems({
        payload: { body: file }
      })
      setItemsInfo([
        ...response.data.map((el: any, index: number) => {
          return {
            ...el,
            id: 200 + index
          }
        }),
        ...itemsInfo
      ])
      setExtractLoading(false)
      setNotFounded([])
    } catch (error) {
      if (error.response.data.errorKey === 'items.externalCode.notFound') {
        setNotFounded(error.response.data['items.externalCode.notFound'])
      }
      setExtractLoading(false)
      handleNotification(
        'فایل خود را بعد از بازنگری دوباره آپلود کنید.',
        'error'
      )
    }
  }
  const extractOrderItem = () => {
    if (!isInvoiceValid) {
      handleNotification('ابتدا فایل فاکتور خود را باگذاری کنید.', 'error')
      return
    }
    setExtractLoading(true)
    getOrderWithFile()
  }
  const onSelectContact = (contact: Contact) => {
    setValue('customerName', contact.fullName)
    setValue('customerProvince', contact.province)
    setValue('customerCity', contact.city)
    setValue('customerMobileNumber', contact.mobile)
    setValue('customerAddress', contact.address)
    setValue('customerZipCode', contact.postalCode ? contact.postalCode : '')
    setValue(
      'customerNationalCode',
      contact.nationalCode ? contact.nationalCode : ''
    )
    setLocations({
      lat: contact.lat,
      lng: contact.lon
    })
    setDialog('')
  }
  const onContactDelete = (e: any, id: string) => {
    e.preventDefault()
    e.stopPropagation()
    setSelected(id)
    setDialog('DELETE')
  }

  const deleteContact = async () => {
    try {
      await ContactsRepository.deleteContact({
        payload: {
          id: selected
        }
      })
      setDialog('')
    } catch (error) {
      handleError(error)
    }
  }

  useEffect(() => {
    if (contactsCourier.length > 0) {
      const contact = contactsCourier.find(
        (item: any) => item.specialContactId === contactId
      )
      setListContact(contact)
    } else {
      setListContact(null)
    }
  }, [contactId, dataShipping])

  return (
    <React.Fragment>
      <Helmet>
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Helmet>

      <Typography variant='h6' component='h1' style={{ marginBottom: '24px' }}>
        <Button onClick={() => history.goBack()}>
          <RonadIcons name='chevronRight' />
        </Button>
        {editMode ? `${' '} ویرایش سفارش  ${orderId} ` : `${' '} ایجاد سفارش `}
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid lg={12} md={12} container style={{ width: '100%' }}>
          {/* Order Info Section */}
          <div
            style={{
              backgroundColor: '#fff',
              padding: '24px',
              borderRadius: '4px'
            }}
          >
            <Typography
              variant='h6'
              component='h2'
              style={{ fontWeight: 'bold' }}
            >
              اطلاعات سفارش
            </Typography>
            <Card className={classes.card}>
              <CardContent className={classes.cardContentOrder}>
                <Grid
                  container
                  alignItems='stretch'
                  justifyContent='space-between'
                  spacing={2}
                >
                  <OrderInputs
                    editMode={editMode}
                    form={form}
                    orderValue={orderValue}
                    setOrderValue={setOrderValue}
                    cost={cost}
                    setCost={setCost}
                    setDataShipping={setDataShipping}
                    setFulfillmentTypes={setFulfillmentTypes}
                    setFormFieldsId={setFormFieldsId}
                    SetExtraLabelRequired={SetExtraLabelRequired}
                    SetAddressDisabled={SetAddressDisabled}
                    setDeliveryTime={setDeliveryTime}
                    setLocatedInTehran={setLocatedInTehran}
                    setContactsCourier={setContactsCourier}
                    setLoadReceiverInfo={setLoadReceiverInfo}
                    setCheckFilesRequired={setCheckFilesRequired}
                  />
                  <Grid container item md={4} spacing={3} style={{ margin: 0 }}>
                    <Grid item md={6}>
                      <FileWithLink
                        id='invoice'
                        isloading={isInvoiceLoading}
                        checkFilesRequired={checkFilesRequired}
                        handleChangeFileInput={invoiceFileChange}
                        number={numberInvoiceFile}
                        file={invoiceFile}
                        getFile={() => getOrderFile('RECEIPT')}
                        fileName={invoiceFileName}
                        link={invoiceLink}
                        onClick={() => setDialog('invoiceModal')}
                        lable={
                          checkFilesRequired
                            ? 'رسید محموله دیجی‌کالا (pdf)'
                            : 'افزودن فایل فاکتور (pdf)'
                        }
                        trash='حذف رسید محموله'
                        onDelete={onInvoiceDelete}
                        accept='.pdf'
                      />
                    </Grid>
                    <Grid item md={6}>
                      <FileWithLink
                        id='label'
                        isloading={isLabelLoading}
                        checkFilesRequired={checkFilesRequired}
                        handleChangeFileInput={labelFileChange}
                        number={numberLabelFile}
                        file={labelFile}
                        getFile={() => getOrderFile('LABEL')}
                        fileName={labelFileName}
                        link={labelLink}
                        disabled={!extraLabelRequired}
                        onClick={() => setDialog('labelModal')}
                        lable={
                          checkFilesRequired
                            ? 'لیبل محموله دیجی‌کالا (pdf)'
                            : 'افزودن لیبل دیجی‌کالا (pdf)'
                        }
                        trash='حذف لیبل'
                        onDelete={onLabelDelete}
                        accept='.pdf'
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {editMode && !LoadReceiverInfo ? (
              <></>
            ) : (
              <>
                <div style={{ display: 'flex' }}>
                  <Typography
                    variant='h6'
                    component='h2'
                    style={{ fontWeight: 'bold' }}
                  >
                    اطلاعات ارسال
                  </Typography>
                  {contactsCourier.length < 1 && (
                    <RonadIcons
                      name='addressBook'
                      style={{ marginRight: '5px', color: '#f39869' }}
                      size={1.3}
                      onClick={() => setDialog('CONTACTS')}
                    />
                  )}
                </div>
                {contactsCourier.length < 1 ? (
                  <CustomerInfo
                    form={{
                      errors,
                      watch,
                      setValue,
                      getValues,
                      register,
                      control
                    }}
                    fulfillmentService={fulfillmentLine}
                    cod={cod}
                    deliveryLocationType={deliveryLocationType}
                    handleLocations={handleLocations}
                    location={location}
                    addressDisabled={addressDisabled}
                    locatedInTehran={locatedInTehran}
                    editMode={editMode}
                  />
                ) : (
                  <InputContacts
                    form={{
                      errors,
                      watch,
                      setValue,
                      control
                    }}
                    contactsCourier={contactsCourier}
                    setContactId={setContactId}
                  />
                )}
              </>
            )}
            {/* Product List Section */}
            <Typography
              variant='h6'
              component='h2'
              style={{ fontWeight: 'bold' }}
            >
              کالاهای سفارش
            </Typography>
            <ProductList
              isVitrinOrderItem={isVitrinOrderItem}
              setIsVitrinOrderItem={setIsVitrinOrderItem}
              setDialog={setDialog}
              itemsInfo={itemsInfo}
              setConfirmDelete={setConfirmDelete}
              extractItems={extractOrderItem}
              fulfillmentService={fulfillmentLine}
              editMode={editMode}
              setNumberProductList={setNumberProductList}
              notFounded={notFounded}
              extraLabelRequired={extraLabelRequired}
            />
            <Grid container justifyContent='flex-end'>
              {disableElement(features) ? (
                <Button
                  type='button'
                  disabled
                  size='medium'
                  variant='contained'
                  color='primary'
                  style={{
                    marginRight: '14px'
                  }}
                  id='saveOrder'
                >
                  {editMode ? 'ذخیره تغییرات' : 'ایجاد سفارش'}
                </Button>
              ) : (
                <Button
                  type='submit'
                  size='medium'
                  variant='contained'
                  color='primary'
                  style={{
                    marginRight: '14px'
                  }}
                  id='saveOrder'
                >
                  {editMode ? 'ذخیره تغییرات' : 'ایجاد سفارش'}
                </Button>
              )}
            </Grid>
          </div>
        </Grid>
      </form>
      <ConfirmModal
        open={dialog === 'confirmationOrder'}
        onClose={() => setDialog('')}
        onSubmit={handleSubmitOrder}
        loading={submitLoading}
      >
        {notMatch !== '' && (
          <Typography style={{ marginBottom: '10px' }} variant={'h6'}>
            {notMatch}
          </Typography>
        )}

        <Typography variant={'h6'}>
          {`آیا از ${editMode ? 'ویرایش' : 'ایجاد'} سفارش ${
            editMode ? orderId : 'جدید'
          } مطمئن هستید؟`}
        </Typography>
      </ConfirmModal>
      <ConfirmModal
        open={dialog === 'DELETE'}
        onClose={() => setDialog('')}
        onSubmit={deleteContact}
        loading={submitLoading}
      >
        <Typography variant={'h6'}>
          {`آیا از حذف مخاطب مطمئن هستید؟`}
        </Typography>
      </ConfirmModal>
      <Dialog
        open={['invoiceModal', 'labelModal'].includes(dialog)}
        fullWidth
        onClose={handleCloseFactorModal}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent
          style={{ width: '100', marginBottom: '16px', overflow: 'hidden' }}
        >
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10
            }}
          >
            <IconButton aria-label='close' onClick={handleCloseFactorModal}>
              <RonadIcons name='times' size={0.8} />
            </IconButton>
          </div>
          <div className={classes.cancelIcon}>
            <Typography variant={'h6'}>وارد کردن آدرس</Typography>
          </div>
          <div>
            <Box mt={3} />
            <Grid xs={12} container justifyContent='center'>
              {dialog == 'invoiceModal' && (
                <Grid
                  container
                  item
                  xs={12}
                  alignItems='flex-end'
                  style={{ marginBottom: '16px' }}
                >
                  <div className={classes.item}>
                    <div style={{ width: '100%' }}>
                      <TextField
                        variant='outlined'
                        error={linkValidation(invoiceLink)}
                        fullWidth
                        type='text'
                        value={invoiceLink}
                        onChange={handleInvoiceLink}
                        helperText={
                          linkValidation(invoiceLink) &&
                          'مقدار وارد شده باید از نوع آدرس اینترنتی باشد'
                        }
                        label={
                          <Grid container alignItems='center'>
                            <span style={{ marginRight: '5px' }}>
                              {'آدرس فایل مورد نظر خود را وارد کنید'}
                            </span>
                          </Grid>
                        }
                      />
                    </div>
                  </div>
                </Grid>
              )}
              {dialog == 'labelModal' && (
                <Grid container item xs={12} alignItems='flex-end'>
                  <div className={classes.item}>
                    <TextField
                      variant='outlined'
                      error={linkValidation(labelLink)}
                      fullWidth
                      type='text'
                      value={labelLink}
                      onChange={(e) => setLabelLink(e.target.value)}
                      helperText={
                        linkValidation(labelLink) &&
                        'مقدار وارد شده باید از نوع آدرس اینترنتی باشد'
                      }
                      label={
                        <Grid container alignItems='center'>
                          <span style={{ marginRight: '5px' }}>
                            {'آدرس فایل مورد نظر خود را وارد کنید'}
                          </span>
                        </Grid>
                      }
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions className={classes.actionsBox}>
          <Button
            autoFocus
            onClick={handleCloseFactorModal}
            variant='outlined'
            color='primary'
            size='large'
            style={{ flex: '1 1 0' }}
          >
            {'انصراف'}
          </Button>
          <Button
            color='primary'
            fullWidth
            variant='contained'
            disabled={isLinkAddressButtonDisabled()}
            onClick={() => setDialog('')}
            size='large'
            style={{ flex: '1 1 0' }}
          >
            {'بارگذاری فاکتور'}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialog === 'CONTACTS'}
        fullWidth
        onClose={handleCloseFactorModal}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent
          style={{
            width: '100',
            marginBottom: '16px',
            minHeight: '500px',
            maxHeight: '500px'
          }}
        >
          <ContactList onDelete={onContactDelete} onSelect={onSelectContact} />
        </DialogContent>
      </Dialog>
      <Dialog
        open={dialog === 'openConfirmDelete'}
        onClose={() => setDialog('')}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent style={{ paddingTop: '0' }}>
          <div
            style={{
              position: 'absolute',
              left: '3px',
              top: '10px',
              zIndex: 10
            }}
          >
            {setDialog ? (
              <IconButton aria-label='close' onClick={() => setDialog('')}>
                <RonadIcons name='times' size={0.8} />
              </IconButton>
            ) : null}
          </div>

          <div
            className={classes.cancelTitle}
          >{`از لغو کالا با شناسه ${itemDeleted.id} مطمئن هستید؟`}</div>
          <Divider
            style={{ width: '100%', marginLeft: '0', marginRight: '0' }}
          />
        </DialogContent>
        <DialogActions style={{ padding: '15px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                onClick={() => setDialog('')}
                variant='outlined'
                color='primary'
                size='large'
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                color='primary'
                variant='contained'
                onClick={deleteItemsFromOrder}
                size='large'
              >
                {'حذف آیتم'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog open={extractLoading} aria-labelledby='responsive-dialog-title'>
        <DialogContent>
          <Typography variant='h4' style={{ padding: '100px' }}>
            در حال استخراج کالاها
          </Typography>
          <div className={classes.loadingTitle}>لطفا منتظر بمانید</div>
          <div style={{ textAlign: 'center', marginBottom: '35px' }}>
            <CircularProgress size={58} />
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={openDialogComparison !== ''}>
        <DialogContent>
          <div className={classes.openDialogComparison}>
            {openDialogComparison}
            <Button
              color='primary'
              variant='contained'
              onClick={() => setOpenDialogComparison('')}
              size='large'
            >
              {'باشه'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Modal
        maxWidth='sm'
        onClose={() => setDialog('')}
        open={dialog === 'openAddItem'}
        title={
          <Typography
            variant='h6'
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به سفارش
          </Typography>
        }
        content={
          <Add
            addItem={(body: AddItemCreateParcel) =>
              editMode ? handleSubmitOrderItems(body) : createItemsToOrder(body)
            }
            fulfillmentService={fulfillmentLine}
            fulfillmentLineId={fulfillmentLine}
            onClose={() => setDialog('')}
          />
        }
      />
      <Modal
        maxWidth='sm'
        onClose={() => setDialog('')}
        open={dialog === 'openAddVitrinItem'}
        title={
          <Typography
            variant='h6'
            style={{ textAlign: 'center', marginTop: '20px' }}
          >
            افزودن کالا به سفارش ویترین
          </Typography>
        }
        content={
          <AddVitrin
            addItem={(body: AddItemCreateParcel) =>
              editMode ? handleSubmitOrderItems(body) : createItemsToOrder(body)
            }
            fulfillmentService={fulfillmentLine}
            fulfillmentLineId={fulfillmentLine}
            onClose={() => setDialog('')}
          />
        }
      />
    </React.Fragment>
  )
}

export default CreateOrder
